export default __webpack_public_path__ + "static/media/close-outline.2f83c186.svg";